




import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    graphData: Array
  }
})
export default class Graph extends Vue {
  private graphData: any = this.graphData;
  private seriesData = [];
  private seriesDataPurchased = [];
  private seriesDataSold = [];

  private chartOptions = {
    title: {
      text: ""
    },
    chart: {
      type: "area",
      zoomType: "x"
    },
    subtitle: {
      text: ""
    },
    exporting: {
      enabled: true,
      csv: {
        columnHeaderFormatter: null,
        dateFormat: "%Y-%m-%d %H:%M:%S",
        decimalPoint: null,
        itemDelimiter: null,
        lineDelimiter: " "
      },
      buttons: {
        contextButton: {
          menuItems: ["downloadPNG", "downloadSVG", "downloadXLS"]
        }
      }
    },

    tooltip: {
      formatter: function() {
        const time = new Date((this as any).x * 1000);
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        let minutes = time.getMinutes();
        let hour = time.getHours();
        let date = time.getDate();
        let month = time.getMonth();
        let minutesString = "";
        let hourString = "";
        if (minutes < 10) {
          minutesString = "0" + minutes.toString();
        } else {
          minutesString = minutes.toString();
        }
        if (hour < 10) {
          hourString = "0" + hour.toString();
        } else {
          hourString = hour.toString();
        }
        return (
          "Time: <b>" +
          date +
          "  " +
          monthNames[month] +
          "  " +
          hourString +
          ":" +
          minutesString +
          "<br>Energy: <b>" +
          Math.round((this as any).y) +
          " W" +
          "</b>"
        );
      }
    },

    yAxis: {
      title: {
        text: "Energy"
      },
      labels: {
        formatter: function() {
          return (this as any).value + "W";
        }
      }
    },
    xAxis: {
      title: {
        text: "Time"
      },
      labels: {
        formatter: function() {
          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
          const time = new Date((this as any).value * 1000);
          let minutes = time.getMinutes();
          let hour = time.getHours();
          let date = time.getDate();
          let month = time.getMonth();
          let minutesString = "";
          let hourString = "";
          if (minutes < 10) {
            minutesString = "0" + minutes.toString();
          } else {
            minutesString = minutes.toString();
          }
          if (hour < 10) {
            hourString = "0" + hour.toString();
          } else {
            hourString = hour.toString();
          }
          return (
            date +
            "  " +
            monthNames[month] +
            "  " +
            hourString +
            ":" +
            minutesString
          );
        }
      }
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle"
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false
        }
      }
    },

    series: [
      {
        name: "Used",
        data: this.seriesDataPurchased
      },
      {
        name: "Generated",
        data: this.seriesData,
        color: "#df8c67"
      },
      {
        name: "Sold",
        data: this.seriesDataSold
      }
    ],

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom"
            }
          }
        }
      ]
    }
  };

  mounted() {
    for (let i = 0; i < this.graphData.length; i++) {
      if (this.graphData[i].timestamp !== 0) {
        this.seriesData.push([
          this.graphData[i].timestamp,
          this.graphData[i].powergenerated
        ] as never);
        this.seriesDataPurchased.push([
          this.graphData[i].timestamp,
          this.graphData[i].powerused == 0
            ? this.graphData[i].powergenerated
            : this.graphData[i].powerused
        ] as never);
        this.seriesDataSold.push([
          this.graphData[i].timestamp,
          this.graphData[i].powersold
        ] as never);
      }
    }
  }

  updated() {}
}
